// How each Customer login status shows (issue #253): the Logins card, the
// Customers list's Logins column and the Login Switcher (issue #283).
export const LOGIN_STATUS = {
  active: { label: 'Active', color: '#1b5e20', background: '#e3f1e4', title: 'Password set. Can sign in to the portal.' },
  invited: { label: 'Invited', color: '#1565c0', background: '#e3eefb', title: 'Invite sent. The link works once and expires 24 hours after it was sent.' },
  invite_expired: { label: 'Invite expired', color: '#b91c1c', background: '#fef2f2', title: 'The invite link expired before a password was set. Re-send it from the row menu.' },
  paused: { label: 'Paused', color: '#8a5a00', background: '#fff3d6' },
  switched_off: { label: 'Switched off', color: '#5a6b85', background: '#eef1f5' },
};
